document.addEventListener('DOMContentLoaded', () => {
  const cartDrawer = document.getElementById('cart-drawer');
  const cartTrigger = document.querySelector('.site-header__cart');

  // Add to cart via AJAX
  document.querySelectorAll('form[action^="/cart/add"]').forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const formData = new FormData(form);

      await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      await updateCartDrawer();
      showAddToCartMessage();
      showContinueShoppingButton();
    });
  });

  // Open cart drawer
  cartTrigger.addEventListener('click', e => {
    e.preventDefault();
    cartDrawer.classList.add('open');
    document.body.classList.add('sf-overlay');
    e.stopPropagation();

    const continueBtn = document.querySelector('.continue-shopping');
    if (continueBtn) {
      continueBtn.style.display = 'none';
    }
  });

  // Close cart on outside click
  document.addEventListener('click', e => {
    const isInsideCart = cartDrawer.contains(e.target);
    const isCartButton = e.target.closest('.site-header__cart');
    if (!isInsideCart && !isCartButton) {
      cartDrawer.classList.remove('open');
      document.body.classList.remove('sf-overlay');
    }
  });

  // Close cart on close button
  document.body.addEventListener('click', e => {
    if (e.target.id === 'close-cart') {
      cartDrawer.classList.remove('open');
      document.body.classList.remove('sf-overlay');
    }
  });

  // Close cart on continue shopping button
  document.body.addEventListener('click', e => {
    if (e.target.classList.contains('continue-shopping')) {
      cartDrawer.classList.remove('open');
      document.body.classList.remove('sf-overlay');
    }
  });

  // Quantity updates
  document.body.addEventListener('click', async e => {
    if (e.target.classList.contains('qty-btn')) {
      const wrapper = e.target.closest('.quantity-wrapper');
      const input = wrapper.querySelector('.cart-qty');
      const key = input.dataset.key;
      let qty = parseInt(input.value);

      qty += e.target.classList.contains('plus') ? 1 : -1;
      qty = Math.max(qty, 1);

      input.value = qty;

      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });

      await updateCartDrawer();
    }
  });

  // Remove cart item
  document.body.addEventListener('click', async e => {
    if (e.target.classList.contains('remove-item')) {
      const key = e.target.dataset.key;
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
      await updateCartDrawer();
    }
  });

  // Refresh cart drawer content
  async function updateCartDrawer() {
    const response = await fetch('/?section_id=cart-drawer');
    const text = await response.text();
    const temp = document.createElement('div');
    temp.innerHTML = text;

    const newDrawer = temp.querySelector('#cart-drawer');
    const current = document.getElementById('cart-drawer');

    if (newDrawer && current) {
      current.innerHTML = newDrawer.innerHTML;
      current.classList.add('open');
      document.body.classList.add('sf-overlay');
    } else {
      console.warn('Cart drawer not found in returned HTML');
    }

    const cartData = await fetch('/cart.js').then(res => res.json());
    $('.site-header__cart-indicator').text(cartData.item_count);
  }

  // Show "Added to Cart" message
  function showAddToCartMessage() {
    const addToCartMessage = document.querySelector('.cart-add-to-cart');
    if (addToCartMessage) {
      addToCartMessage.style.display = 'block';
      setTimeout(() => {
        addToCartMessage.style.display = 'none';
      }, 4000);
    }
  }

  // Show "Continue Shopping" button
  function showContinueShoppingButton() {
    const continueBtn = document.querySelector('.continue-shopping');
    if (continueBtn) {
      continueBtn.style.display = 'inline-block';
    }
  }

  // ✅ Toggle .cart__note visibility when label is clicked

  document.addEventListener('click', function (e) {
  const label = e.target.closest('.medium-up--one-halfcart-block label');
  if (label) {
    const note = document.querySelector('.cart__note');
    if (note) {
      const isHidden = window.getComputedStyle(note).display === 'none';
      note.style.display = isHidden ? 'block' : 'none';
      label.classList.toggle('activnote');
    }
  }
});


});
